/**
 * Where a ranking screen reads its window from.
 *
 * An account reads the window its own strategy published. The platform
 * administrator has no account: it reads the platform's own window, ranked
 * from public market data for the released Candidate. One reader for both, so
 * the two screens can never disagree about which window they show.
 */
import { readPlatformRanking, readRanking } from "@/shared/api";
import type { RankingResponse } from "@/shared/api";

export function rankingKey(platform: boolean): readonly unknown[] {
  return ["ranking", platform ? "platform" : "account"];
}

export async function readCurrentRanking(platform: boolean): Promise<RankingResponse> {
  const { data, error, response } = platform ? await readPlatformRanking() : await readRanking();
  if (error !== undefined || data === undefined) {
    throw Object.assign(new Error("ranking unreadable"), { status: response?.status });
  }
  return data;
}
